import { render, staticRenderFns } from "./personageData.vue?vue&type=template&id=12f88d88&scoped=true&"
import script from "./personageData.vue?vue&type=script&lang=js&"
export * from "./personageData.vue?vue&type=script&lang=js&"
import style0 from "./personageData.vue?vue&type=style&index=0&id=12f88d88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f88d88",
  null
  
)

export default component.exports